import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse as RawCollapse } from 'react-collapse';
import ChevronDownIcon from '../../assets/icons/ChevronDownIcon';
import ChevronUpIcon from '../../assets/icons/ChevronUpIcon';
import { OuterContainer, Container, Heading } from './Collapse.styles';

interface CollapseProps {
  heading: string;
  children: React.ReactNode;
}

const Collapse: React.FC<CollapseProps> = ({ heading, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const { t } = useTranslation();

  const handleClick = () => setIsOpen(!isOpen);
  const handleWork = () => setIsAnimating(true);
  const handleRest = () => setIsAnimating(false);

  return (
    <OuterContainer>
      <Container
        onClick={handleClick}
        aria-label={`${heading} ${
          isOpen ? t(`vehicleHistory.ariaLabel.expanded`) : t(`vehicleHistory.ariaLabel.contracted`)
        }`}
      >
        <Heading>{heading}</Heading>
        {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </Container>
      {/* To prevent focus on hidden elements we only render them as needed */}
      <RawCollapse isOpened={isOpen} onWork={handleWork} onRest={handleRest}>
        <>{(isOpen || isAnimating) && children}</>
      </RawCollapse>
    </OuterContainer>
  );
};

export default Collapse;
